import { render } from "./EditDemoContent.vue?vue&type=template&id=767578f5"
import script from "./EditDemoContent.vue?vue&type=script&lang=js"
export * from "./EditDemoContent.vue?vue&type=script&lang=js"

import exportComponent from "/home/peter/new-demo-tool/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__